import styled, { css } from 'styled-components/macro'

import Icon from '../../atoms/Icon/Icon';
// import SlideDownContainer from '../../atoms/SlideDownContainer/SlideDownContainer';

import { settings } from '../../../styled/settings/index';
import { mixins } from '../../../styled/mixins/index';
import { mobile } from '../../../styled/settings/mediaqueries';

const {
  colors: { color, hexToRGBa },
  fonts: { brandonGrotesqueMedium },
  mediaqueries: { mobileDown, tabletLandscapeDown, tabletLandscapeUp, tabletPortraitDown, tabletPortraitUp },
  sizing: { fontsize, spacingsize, radiussize },
  shadows: { buttonShadowDefault },
} = settings;

const {
  typography: { buttonText },
} = mixins;

export const NavigationContainer = styled.div`
  /* position: fixed;
  top: 0; */
  height: 100vh;
  width: 100vw;
  background-color: ${color(`black`)};

  @media ${tabletPortraitDown} {
    
  }
`;

export const HeaderMobileContainer = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 999;
  background-color: #000;

  @media ${tabletLandscapeUp} {
    display: none;
  }

  @-webkit-keyframes ${NavigationContainer} {
    100% { top: 0; }
  }

  @keyframes ${NavigationContainer} {
    100% { top: 0; }
  }
`;

export const HeaderMobileInnerContainer = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;

  @media ${tabletPortraitDown} {

  }

  @media ${mobileDown} {
    
  }
`;

export const OpenCloseButtonContainer = styled.div`
  grid-column-start: 1;
  grid-column-end: 2;
  display: flex;
  align-items: center;
  padding-left: ${spacingsize(7)};
`;

const iconButtonStyles = css`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
`;

export const OpenMenuButton = styled(Icon)`
  ${iconButtonStyles}
  height: 35px;
  width: 35px;
  
  g, rect, path {
    fill: ${color(`teal`)};
  }
`;

export const CloseMenuButton = styled(Icon)`
  ${iconButtonStyles}
  height: 35px;

  g, rect, path {
    fill: ${color(`teal`)};
  }
`;

export const LogoContainer = styled.div`
  grid-column-start: 2;
  grid-column-end: 3;
  display: flex;
  justify-content: flex-end;

  @media ${tabletPortraitDown} {
    
  }

  @media ${mobileDown} {
    
  }
`;

export const LogoLink = styled.a`
  text-decoration: none;
  display: flex;
  align-items: center;
`;

export const LogoImage = styled.img`
  padding: ${spacingsize(8)};
  width: 100%;
  max-width: 250px;
`;

// export const NavigationMenuContainer = styled(SlideDownContainer)`
//   z-index: 9999;
// `;

export const NavigationMenuContainer = styled.div`
  position: fixed;
  top: 0;
  z-index: 9999;
`;

export const NavigationHeaderContainer = styled.div`
  /* position: fixed;
  top: 0; */
  width: 100%;
  z-index: 9999;
  background-color: #000;
`;

export const NavigationHeaderInnerContainer = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
`;

const navigationItemSpacing = spacingsize(7);

export const Navigation = styled.ul`
  list-style: none;
  background: ${color(`black`)};
  padding: 0;
  /* padding: ${spacingsize(7)} 0 0 0; */
  margin: 0;
  
  /* @media ${tabletPortraitDown} {
    margin-top: 4.6875rem;
  }
  
  @media ${mobileDown} {
    margin-top: 5.5rem;
  } */
`;

export const navigationItemsText = css`
  ${brandonGrotesqueMedium}
  text-transform: uppercase;
  font-size: ${fontsize(6)};

  @media ${tabletLandscapeDown} {
    font-size: ${fontsize(5)};
  }

  @media ${tabletPortraitDown} {
    font-size: ${fontsize(5)};
  }

  @media ${mobileDown} {
    font-size: ${fontsize(5)};
  }
`;

export const CtaContainer = styled.div`
  padding-top: ${spacingsize(7)};
`;

export const CtaInnerContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const ButtonContainer = styled.div`
  display: flex;
  padding: ${spacingsize(8)};
`;

const ctaButtonText = css`
  ${navigationItemsText}
  text-decoration: none;
  text-transform: uppercase;
  padding: ${spacingsize(5)};
`;

export const ApplyButton = styled.a`
  ${ctaButtonText}
  background-color: ${color(`white`)};
  color: ${color(`black`)};
  border: solid 1px ${color(`white`)};

  &:hover{
    background-color: ${color(`teal`)};
  }
`;

export const BookATourButton = styled.a`
  ${ctaButtonText}
  background-color: ${color(`teal`)};
  color: ${color(`black`)};
  border: solid 1px ${color(`teal`)};

  &:hover{
    background-color: ${color(`white`)};
  }
`;